import React from 'react';
import { Box } from '@mui/material';
import AppDialog, { ModalButton } from './common/AppDialog';
import FableTokenAmount from './common/FableTokenAmount';

interface LottieModalProps {
  open: boolean;
  onClose: () => void;
  onEntered?: () => void;
  showCloseButton?: boolean;
  animationData?: any;
  title: string;
  description: React.ReactNode;
  primaryButtonText: React.ReactNode;
  primaryButtonAction: () => void;
  primaryButtonForm?: string;
  primaryButtonDisabled?: boolean;
  secondaryButtonText?: React.ReactNode;
  secondaryButtonAction?: () => void;
  secondaryButtonDisabled?: boolean;
  tertiaryButtonText?: React.ReactNode;
  tertiaryButtonAction?: () => void;
  tertiaryButtonDisabled?: boolean;
  coinIcon?: boolean;
  coinCount?: string;
  animationSpeed?: number;
  children?: React.ReactNode;
}

/** Animated content for AppDialog; naming, confirmation and token prompts share its UX. */
const LottieModal: React.FC<LottieModalProps> = ({
  open, onClose, onEntered, showCloseButton, animationData, title, description,
  primaryButtonText, primaryButtonAction, primaryButtonForm, primaryButtonDisabled = false,
  secondaryButtonText, secondaryButtonAction, secondaryButtonDisabled = false,
  tertiaryButtonText, tertiaryButtonAction, tertiaryButtonDisabled = false,
  coinIcon: showCoinIcon = false, coinCount = '1',
  animationSpeed = 1, children,
}) => {
  return <AppDialog
    open={open}
    onClose={onClose}
    onEntered={onEntered}
    showCloseButton={showCloseButton}
    title={title}
    description={description}
    animationData={animationData}
    animationSpeed={animationSpeed}
    actions={[
      tertiaryButtonText && tertiaryButtonAction && <ModalButton key="tertiary" tone="secondary"
        onClick={tertiaryButtonAction} disabled={tertiaryButtonDisabled}>{tertiaryButtonText}</ModalButton>,
      secondaryButtonText && secondaryButtonAction && <ModalButton key="secondary" tone="secondary"
        onClick={secondaryButtonAction} disabled={secondaryButtonDisabled}>{secondaryButtonText}</ModalButton>,
      <ModalButton key="primary"
        type={primaryButtonForm ? 'submit' : 'button'} form={primaryButtonForm}
        onClick={primaryButtonForm ? undefined : primaryButtonAction} disabled={primaryButtonDisabled}>
        <Box component="span" sx={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 0.75 }}>
          <Box component="span">{primaryButtonText}</Box>
          {showCoinIcon && <>
            <Box component="span" sx={{ opacity: 0.82 }}>|</Box>
            <FableTokenAmount amount={coinCount} kind="price" />
          </>}
        </Box>
      </ModalButton>,
    ]}
  >{children}</AppDialog>;
};

export default LottieModal;
